import { EnvironmentOutlined, LeftOutlined } from '@ant-design/icons';
import { Flex } from 'antd';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Fragment } from 'react/jsx-runtime';
import { getStoreOrders, emitter } from '../../../store/StoreUtils';

interface HeaderProps {
  itemsBack: () => void;
  step: number;
}

const CustomOrderMobileHeader = ({ itemsBack, step }: HeaderProps) => {
  const [counter, setCounter] = useState(0);

  const getOrderCount = () => {
    const orders = getStoreOrders();
    setCounter(orders.length || 0);
  };

  useEffect(() => {
    getOrderCount();
    emitter.addListener(
      'localOrderChange',
      () => {
        getOrderCount();
      },
      null
    );
  }, []);
  return (
    <div className="header">
      <Flex justify="space-between" align="center">
        <Flex gap={12}>
          {step === 0 ? (
            <Fragment>
              <EnvironmentOutlined onClick={itemsBack} />
              <span>Хаягийн мэдээлэл</span>
            </Fragment>
          ) : null}
          {step === 1 ? (
            <Fragment>
              <LeftOutlined onClick={itemsBack} />
              <span>Илгээмжийн мэдээлэл</span>
            </Fragment>
          ) : null}
          {step === 2 ? (
            <Fragment>
              <LeftOutlined onClick={itemsBack} />
              <span>Төлбөрийн мэдээлэл</span>
            </Fragment>
          ) : null}
        </Flex>
        {counter ? (
          <Link style={{ color: '#FFF' }} to={'/customer-order/list'}>
            Захиалга ({counter})
          </Link>
        ) : null}
      </Flex>
    </div>
  );
};

export default CustomOrderMobileHeader;
